import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

export const constantRoutes = [
  { 
    path: '/login',
    component: () => import('@/pages/login'),
    hidden: true,
    meta:{
      title: 'login'
    }
  },
  { 
    path: '/code',
    component: () => import('@/pages/ueditor'),
    hidden: true,
    meta:{
      title: 'code'
    }
  },
  { 
    path: '',
    component: Layout,
    hidden: true,
    redirect: '/login',
    children: [
      { 
        path: '/upData',
        name: 'upData',
        component: () => import('@/pages/upData'),
        meta: {
          title:'upData',
      	}
      },
      { 
        path: '/studyList',
        name: 'studyList',
        component: () => import('@/pages/infoList/index'),
        meta: {
          title:'studyList',
        }
      },
      { 
        path: '/aiAnalysis',
        name: 'aiAnalysis',
        component: () => import('@/pages/aiAnalysis'),
        meta: {
          title:'aiAnalysis',
        }
      },
      { 
        path: '/personalCenter',
        name: 'personalCenter',
        component: () => import('@/pages/personalCenter'),
        meta: {
          title:'personalCenter',
      	  }
      },
      { 
        path: '/doctorList',
        name: 'doctorList',
        component: () => import('@/pages/doctorList'),
        meta: {
          title:'doctorList',
      	  }
      },
      { 
        path: '/downList',
        name: 'downList',
        component: () => import('@/pages/download'),
        meta: {
          title:'doctorList',
      	}
      },
      { 
        path: '/queryList',
        name: 'queryList',
        component: () => import('@/pages/queryList/index'),
        meta: {
          title:'queryList',
      	}
      },
      { 
        path: '/myShift',
        name: 'myShift',
        component: () => import('@/pages/myShift'),
        meta: {
          title: 'myShift',    
      	  }
      },
      { 
        path: '/shiftDoctors',
        name: 'shiftDoctors',
        component: () => import('@/pages/shiftDoctors'),
        meta: {
          title: 'shiftDoctors',    
      	  }
      },
      {
        path: '/user',
        name: 'user',
        component: () => import('@/pages/userManage/userLayout'),
        redirect: '/user/muList',
        meta:{
           title:'user'
        },
        children: [
          {
            path: 'userList',
            name: 'userList',
            component: () => import('@/pages/userManage/userList'),
            meta: {
              title: 'userList',
              keepAlive: false
            }
          },
          {
            path: 'userAdd',
            name: 'userAdd',
            component: () => import('@/pages/userManage/userAdd'),
            meta: {
              title:'userAdd',
              keepAlive: false,
              activeMenu:'/user/userList'
            }
          },
          {
            path: 'muList',
            name: 'muList',
            component: () => import('@/pages/userManage/muList'),
            meta: {
              title:'muList',
              keepAlive: false
            }
          },
          {
            path: 'muAdd',
            name: 'muAdd',
            component: () => import('@/pages/userManage/muAdd'),
            meta: {
              title:'muAdd',
              keepAlive: false,
              activeMenu:'/user/muList'
            }
          },
          {
            path: 'hospitalList',
            name: 'hospitalList',
            component: () => import('@/pages/userManage/hospitalList'),
            meta: {
              title: 'hospitalList',
              keepAlive: false
            }
          },
          {
            path: 'hospitalAdd',
            name: 'hospitalAdd',
            component: () => import('@/pages/userManage/hospitalAdd'),
            meta: {
              title: 'hospitalAdd',
              keepAlive: false,
              activeMenu:'/user/hospitalList'
            }
          }
        ]
      },
      {
        path: '/role',
        name: 'role',
        meta:{
           title: 'role'
        },
        component: () => import('@/pages/roleManage/roleLayout'),
        redirect: '/role/cloudAcc',
        children: [
          {
            path: 'cloudAcc',
            name: 'cloudAcc',
            component: () => import('@/pages/roleManage/roleAcc'),
            meta: {
              title: 'cloudAcc',
              keepAlive: false
            }
          },
          {
            path: 'muAcc',
            name: 'muAcc',
            component: () => import('@/pages/roleManage/roleAcc'),
            meta: {
              title:'muAcc',
              keepAlive: false
            }
          },
          {
            path: 'hospitalAcc',
            name: 'hospitalAcc',
            component: () => import('@/pages/roleManage/roleAcc'),
            meta: {
              title: 'hospitalAcc',
              keepAlive: false
            }
          }
        ] 
      },
       {
        path: '/statistics',
        name: 'statistics',
        component: () => import('@/pages/statistics/index'),
        meta: {
          title:'statistics'
        },
      }
      // {
      //   path: '/statistics',
      //   name: 'statistics',
      //   component: () => import('@/pages/roleManage/roleLayout'),
      //   redirect: '/statistics/status',
      //   meta: {
      //     title:'statistics'
      //   },
      //   children: [
      //     {
      //       path: 'status',
      //       name: 'status',
      //       component: () => import('@/pages/statistics/status'),
      //       meta: {
      //         title:'status',
      //         keepAlive: false
      //       }
      //     },{
      //       path: 'quality',
      //       name: 'quality',
      //       component: () => import('@/pages/statistics/status'),
      //       meta: {
      //         title:'quality',
      //         keepAlive: false
      //       }
      //     },
      //     {
      //       path: 'editReport',
      //       name: 'editReport',
      //       component: () => import('@/pages/statistics/amount'),
      //       meta: {
      //         title:'editReport',
      //         keepAlive: false
      //       }
      //     },
      //     {
      //       path: 'checkReport',
      //       name: 'checkReport',
      //       component: () => import('@/pages/statistics/amount'),
      //       meta: {
      //         title:'checkReport',
      //         keepAlive: false
      //       }
      //     },
      //   ] 
      // },
    ]
  },
  {
    path: '',
    component: () => import('@/pages/layout_s'),
    hidden: true,
    children: [
      { // 选择用户身份
        path: '/chooseUser',
        component: () => import('@/pages/chooseUser'),
      },
      { // 报告
        path: '/report',
        component: () => import('@/pages/report/index'),
        meta: {
          title:'report'
        }
      },
      { // 报告模板编辑
        path: '/editTemplate',
        component: () => import('@/pages/editTemplate'),
        meta: {
          title:'editTemplate'
        }
      },
      { // 报告打印
        path: '/report/print',
        component: () => import('@/pages/print.vue'),
        meta: {
          title:'print'
        }
      }
    ]
  },
  { // 报告pdf
    path: '/reportpdf',
    component: () => import('@/pages/report/pdf'),
    meta: {
      title:'报告pdf'
    }
  },
  {
    path: '/404',
    component: () => Layout,
    redirect: '/studyList',
    hidden: true
  },
  { path: '*', redirect: '/404', hidden: true }

]

// 左侧导航栏路由表(需要权限id)
export const asyncRoutes = [
  {
    path: '/upData',
    meta: {
      id: 300001,
      title: 'upData',
      icon: 'data'
    },
    children: []
  },
  {
    path: '/studyList',
    meta: {
      id: 600001,
      title: 'studyList',
      icon: 'list'
    },
    children: []
  },
  { 
    path: '/aiAnalysis',
    name: 'aiAnalysis',
    component: () => import('@/pages/aiAnalysis'),
    meta: {
      id:210001,
      title:'aiAnalysis',
      icon: 'aiAnalysis'
    },
    children: []
  },
  {
    path: 'user',
    meta: {
      id: 500001,
      title: 'peoples',
      icon: 'peoples'
    },
    children: [
      {
        path: '/user/muList',
        meta: {
          id: 700001,
          title: 'muList'
        },
        children: []
      },
      {
        path: '/user/hospitalList',
        meta: {
          id: 800001,
          title: 'hospitalList'
        },
        children: []
      },
      {
        path: '/user/userList',
        meta: {
          id: 900001,
          title: 'userList'
        },
        children: []
      }
    ]
  },
  {
    path: 'role',
    meta: {
      id: 400001,
      title: 'role',
      icon: 'lock'
    },
    children: [
      {
        path: '/role/cloudAcc',
        meta: {
          id: 110001,
          title: 'cloudAcc'
        },
        children: []
      },
      {
        path: '/role/muAcc',
        meta: {
          id: 120001,
          title: 'muAcc'
        },
        children: []
      },
      {
        path: '/role/hospitalAcc',
        meta: {
          id: 130001,
          title: 'hospitalAcc'
        },
        children: []
      }
    ]
  },
  {
    path: '/myShift',
    meta: {
      id: 140002,
      title: 'myShift',
      icon: 'shift'
    },
    children: []
  },
  { //服务统计
    path: '/statistics',
    meta: {
      id: 190001,
      title: 'statistics',
      icon: 'statistics'
    },
    children: [
      // {
      //   // 服务状态
      //   path: 'status',
      //   meta: {
      //     id: 190002,
      //     title: '服务进度统计分析'
      //   },
      // },
      {
        path: 'editReport',
        meta: {
          id: 190002,
          title: 'editReport'
        },
      },
      {
        path: 'checkReport',
        meta: {
          id: 190002,
          title: 'checkReport'
        },
      },
    ]
  },
  {
    path: '/personalCenter',
    meta: {
      id: 140001,
      title: 'personalCenter',
      icon: 'user'
    },
    children: []
  },
  {
    path: '/shiftDoctors',
    meta: {
      id: 140003,
      title: 'shiftDoctors',
      icon: 'doctors'
    },
    children: []
  },
  {
    path: '/doctorList',
    meta: {
      id: 2100001,
      title: 'doctorList',
      icon: 'online'
    },
    children: []
  },
  {
    path: '/queryList',
    meta: {
      id: 2100002,
      title: 'queryList',
      icon: 'search'
    },
    children: []
  },
  {
    path: '/downList',
    meta: {
      id: 600001,
      title: 'downList',
      icon: 'down'
    },
    children: []
  },
]

const createRouter = () => new Router({
  mode: process.env.NODE_ENV == 'electron'?'hash':'history',  // 网页和 electron 配置不一样
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
